/* eslint-disable @scandipwa/scandipwa-guidelines/export-level-one */
/*
 * @category  Puma
 * @author    Deniss Dubinins <denissd@scandiweb.com | info@scandiweb.com>
 * @license   http://opensource.org/licenses/OSL-3.0 The Open Software License 3.0 (OSL-3.0)
 * @copyright Copyright (c) 2022 Scandiweb, Inc (https://scandiweb.com)
 */

import MenuQuery from 'Query/Menu.query';
import { Menu } from 'SourceUtil/Menu/Menu';
import { makeCancelable } from 'Util/Promise';
import { prepareQuery } from 'Util/Query';
import { executeGet } from 'Util/Request';
import { hash } from 'Util/Request/Hash';
import { ONE_MONTH_IN_SECONDS } from 'Util/Request/QueryDispatcher';

export * from 'SourceUtil/Menu/Menu';

/** @namespace Util/Menu/getMenuOptions */
const getMenuOptions = () => {
    const {
        header_content: { header_menu } = {}
    } = window.contentConfiguration;

    return { identifier: header_menu };
};

/** @namespace Util/Menu/fetchData */
const fetchData = (rawQueries, onSuccess = () => { }, onError = () => { }) => {
    const preparedQuery = prepareQuery(rawQueries);
    const { query, variables } = preparedQuery;
    const queryHash = hash(query + JSON.stringify(variables));

    if (!window.dataCache) {
        window.dataCache = {};
    }

    if (window.dataCache[queryHash]) {
        onSuccess(window.dataCache[queryHash]);

        return;
    }

    const promise = makeCancelable(
        executeGet(preparedQuery, 'DataContainer', ONE_MONTH_IN_SECONDS)
    );

    promise.promise.then(
        /** @namespace Scandipwa/Util/Menu/fetchData/then */
        (response) => {
            window.dataCache[queryHash] = response;
            onSuccess(response);
        },

        /** @namespace Scandipwa/Util/Menu/fetchData/then/onError/catch */
        (err) => onError(err)
    );
};

/** @namespace Scandipwa/Util/Menu/fetchMenu */
export const fetchMenu = (callback, force = false) => {
    if ((window.headerMenuLoading || window.headerMenu) && !force) {
        if (window.headerMenuLoading) {
            const timeout = 300;

            setTimeout(() => fetchMenu(callback, force), timeout);

            return;
        }

        callback(window.headerMenu);

        return;
    }

    window.headerMenuLoading = true;

    fetchData(
        [MenuQuery.getQuery(getMenuOptions())],
        ({ menu }) => {
            window.headerMenu = menu;
            window.headerMenuLoading = false;

            callback(menu);
        }
    );
};

export default new Menu();
